<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'

      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

            <!-- <label>商品:</label>
            <lk-input clearable v-model='query.nameMix' class="item" placeholder="商品名称、通用名称、助记码、商品编码"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>生产企业:</label>
            <lk-input clearable v-model='query.producer' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input clearable v-model='query.approvalCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>批号:</label>
            <lk-input clearable v-model='query.batchCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model='query.supplierId'/>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class='mb8' >
          <DownloadButton v-if="handlePermission('inspectionDrawerStatsDownloadBtn')" @on-click='handleExport'></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>

import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'inspectionDrawerStats',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
    DownloadButton,
  },
  data() {
    return {
      query: {
        storeIdList: [],
        producer: '',
        approvalCode: '',
        createTimeStart: null,
        createTimeEnd: null,
        nameMix: '',
        batchCode: '',
        supplierId: null,
      },
      columns: [
        {
          title: '行号',
          minWidth: 60,
          render: (h, params) => h('div', params.index + 1),
        },
        {
          title: '门店名称',
          key: 'purchaseDrawerDetailStoreName',
          minWidth: 116,
        },
        {
          title: '创建日期',
          key: 'purchaseDrawerDetailCreateTime',
          minWidth: 116,
        },
        {
          title: '清斗商品名称',
          key: 'clearGoodsName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'clearSpec',
          minWidth: 116,
        },
        {
          title: '产地',
          key: 'clearOrigin',
          minWidth: 116,
        },
        {
          title: '生产厂家',
          key: 'clearProducer',
          minWidth: 116,
        },
        {
          title: '清斗数量',
          key: 'clearGoodsNum',
          minWidth: 116,
        },
        {
          title: '清斗批号',
          key: 'purchaseDrawerDetailClearBatchCode',
          minWidth: 116,
        },
        {
          title: '清斗情况',
          key: 'purchaseDrawerDetailClearRemark',
          minWidth: 116,
        },
        {
          title: '清斗质量情况',
          key: 'purchaseDrawerDetailClearGoodsCondition',
          minWidth: 116,
        },
        {
          title: '清斗人',
          key: 'purchaseDrawerDetailClearUserName',
          minWidth: 116,
        },
        {
          title: '清斗复核人',
          key: 'purchaseDrawerDetailClearReviewerName',
          minWidth: 116,
        },
        {
          title: '装斗商品名称',
          key: 'loadGoodsName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'loadSpec',
          minWidth: 116,
        },
        {
          title: '产地',
          key: 'loadOrigin',
          minWidth: 116,
        },

        {
          title: '生产企业',
          key: 'loadProducer',
          minWidth: 116,
        },
        {
          title: '供应商',
          key: 'purchaseDrawerDetailSupplierName',
          minWidth: 116,
        },
        {
          title: '装斗数量',
          key: 'loadGoodsNum',
          minWidth: 116,
        },
        {
          title: '装斗批号',
          key: 'purchaseDrawerDetailLoadBatchCode',
          minWidth: 116,
        },
        {
          title: '质量状态',
          key: 'purchaseDrawerDetailLoadGoodsCondition',
          minWidth: 116,
        },
        {
          title: '装斗人',
          key: 'purchaseDrawerDetailLoadUserName',
          minWidth: 116,
        },
        {
          title: '装斗复核人',
          key: 'purchaseDrawerDetailLoadReviewerName',
          minWidth: 116,
        },
        {
          title: '剩余库存处理情况',
          key: 'purchaseDrawerDetailClearDrawerTypeName',
          minWidth: 116,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.query = {};
    },
    handleExport() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.inspectionDrawerStatsDownload(params)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      const params = Object.assign({}, this.query);
      params.page = this.page;
      params.size = this.size;
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }

      purchase.inspectionDrawerStats(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseDrawerDetailCreateTime = utils.formatTime(result.purchaseDrawerDetailCreateTime, 'YYYY-MM-DD');
            result.purchaseReceiptInfoExpiryDate = utils.formatTime(result.purchaseReceiptInfoExpiryDate, 'YYYY/MM/DD');
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true);
  },
};
</script>
